import { render, staticRenderFns } from "./abnormal.vue?vue&type=template&id=d1608336&scoped=true"
import script from "./abnormal.vue?vue&type=script&lang=js"
export * from "./abnormal.vue?vue&type=script&lang=js"
import style0 from "./abnormal.vue?vue&type=style&index=0&id=d1608336&prod&lang=scss&scoped=true"
import style1 from "./abnormal.vue?vue&type=style&index=1&id=d1608336&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1608336",
  null
  
)

export default component.exports